<template>
  <v-row justify="center">
    <v-dialog scrollable max-width="600px" v-model="showDialog">
      <template v-slot:activator="{ on }">
        <v-btn color="info" v-on="on">Agregar</v-btn>
      </template>
      <v-card v-if="loading" max-width="800" max-height="80%">
        <v-card-title>
          <h4 v-if="loading">cargando . . .</h4>
        </v-card-title>
      </v-card>
      <v-card max-width="800" height="80%" v-if="!loading">
        <v-card-title>
          <h4>Agregar pago</h4>
        </v-card-title>
        <v-card-text>
          <v-container
            id="scroll-target"
            class="overflow-y-auto"
            style="max-height: 600px"
          >
            <h4>Origen</h4>
            <!-- <v-radio-group v-model="origen" :mandatory="true" row>
              <v-radio label="BNF" value="BNF"></v-radio>
              <v-radio label="GNB" value="GNB"></v-radio>
              <v-radio label="CONTINENTAL" value="CONTINENTAL"></v-radio>
              <v-radio label="VISION BANCO" value="VISION_BANCO"></v-radio>
            </v-radio-group> -->
            <v-select
              v-model="cuentaBancariaId"
              label="Cuenta bancaria"
              :items="cuentasBancarias"
              item-text="descripcion"
              item-value="id"
            />
            <h4>MEDIO PAGO</h4>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Medio de Pago</th>
                    <th class="text-left"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="medio in mediosPagos" :key="medio.id">
                    <td>{{ medio.nombre }}</td>
                    <td>
                      <v-btn small color="info" @click="confirmar(medio.id)"
                        >Seleccionar</v-btn
                      >
                    </td>
                    <!-- <td><v-btn small color="primary" v-if="pago.estado=='Validado'">Anular</v-btn></td> -->
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-container>

        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="info" @click="volver">Volver</v-btn>
          <v-btn color="warning" @click="confirmar">Confirmar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script lang="ts">
import Vue from "vue";
import axios from "axios";

export default Vue.extend({
  data() {
    return {
      loading: false,
      showDialog: false,
      origen: "BNF",
      cuentasBancarias: [],
      cuentaBancariaId: null,
      descripcion: '',
      rules: {
        required: (value) => !!value || "Requerido.",
        counter: (value) => value.length <= 1000 || "Maximo 100 caracteres",
      },
      validForm: false,
    };
  },
  mounted() {
    axios
      .get("/pago/cuentasBancarias")
      .then((response) => {
        console.log(response);
        this.cuentasBancarias = response.data.map((cb) => ({
          id: cb.id,
          descripcion: cb.banco.descripcion + " - " + cb.numero,
        }));
      })
      .catch((err) => {
        if (err && err.response && err.response.data) {
          this.errorMessage = err.response.data;
        } else {
          this.errorMessage = "Error";
        }
      });



    this.loading = true;
    axios
      .get("/medioPago")
      .then((response) => {

        console.log(response);
        this.mediosPagos = response.data.filter(
          (medio) => medio.estado === "ACTIVO"
        );
        this.loading = false;
      })
      .catch((err) => {
        this.loading = false;
        console.log(err);
        this.errorMessage = "Error en la consulta";
      });
  },
  methods: {
    close() {
      this.$refs.form.reset();
      this.showDialog = false;
    },
    confirmar(medioPagoId) {
      this.showDialog = false;
      this.$emit("agregarPago", {
        descripcion: this.descripcion,
        cuentaBancariaId: this.cuentaBancariaId,
        medioPagoId: medioPagoId,
      });
    },
    volver() {
      this.showDialog = false;
    },
  },
});
</script>